module.exports = __webpack_public_path__ + "f59233d4574d58561f09158664753462.png";


//////////////////
// WEBPACK FOOTER
// ./web/images/icons/instagram_icon.png
// module id = 616
// module chunks = 0